export default "__VITE_ASSET__T6WoVKbF__"